module.exports = __webpack_public_path__ + "static/main-sectiom-bg-0f804978649729594595e137573b76fd.png";